export function setFilters({ commit }, filters) {
  commit("setFilters", filters);
}

export function setFilterOptions({ commit }, options) {
  commit("setFilterOptions", options);
}
